import { SelectionOption } from "@core/models";
import { AdditionalDetailsLeaveHours, LeaveListItemAdditionalDetails } from "@core/models/leave-admin/leave-list-item.model";

/**requires reports sysText to match text with object keys*/ 
export function buildAdditionalDetailOptions(reportsSysText: any): SelectionOption[] {
	// build options from the LeaveListItemAdditionalDetails model
	// (each key is an option)

	let options: SelectionOption[] = [];

	const obj: LeaveListItemAdditionalDetails = {
		identities: null,
		
		employeeFirstName: null,
		employeePreferredName: null,
		employeeMiddleName: null,
		employeeLastName: null,
		employeeSuffix: null,
		employeeWorkEmail: null,
		employeePersonalEmail: null,

		supervisors: null,
		hrManager: null,

		workLocation: null,
		workingCity: null,
		workingState: null,

		requestedStartDate: null,
		requestedEndDate: null,
		startDate: null,
		endDate: null,
		leaveReason: null,

		twelveMonthsHours: null,
		twelveMonthsDate: null,
		twelveMonthsComments: null,
		averageWeeklyHours: null,
		averageWeeklyHoursDate: null,
		averageWeeklyHoursComments: null,

		eligibility: null,
		lastRecertDate: null,
		lastDateUsedLeave: null,

		leaveHours: null,

		intermittentFreq: null,
		closeDate: null,
		closeReason: null,
		closeComments: null,
		closedBy: null,
		lastChangeDate: null,
		lastChangedBy: null,
		createDate: null,
		createdBy: null,

		userDefinedFields: null,
	};
	
	Object.keys(obj).forEach(key => {
		options.push({
			id: key,
			description: reportsSysText[key]
		});
	});

	return options;
}

export function getAdditionalDetailLeaveHourFields(): string[] {
	let leaveHourFields: string[] = [];

	const obj: AdditionalDetailsLeaveHours = {
		employeeBank1TotalHours: null,
		employeeBank1UsedHours: null,
		employeeBank1AvailableHours: null,
		employeeBank1FutureHours: null,

		employeeBank2TotalHours: null,
		employeeBank2UsedHours: null,
		employeeBank2AvailableHours: null,
		employeeBank2FutureHours: null,

		employeeBank3TotalHours: null,
		employeeBank3UsedHours: null,
		employeeBank3AvailableHours: null,
		employeeBank3FutureHours: null,

		employeeBank4TotalHours: null,
		employeeBank4UsedHours: null,
		employeeBank4AvailableHours: null,
		employeeBank4FutureHours: null,

		employeeBank5TotalHours: null,
		employeeBank5UsedHours: null,
		employeeBank5AvailableHours: null,
		employeeBank5FutureHours: null,

		leaveCaseBank1UsedHours: null,
		leaveCaseBank1FutureHours: null,

		leaveCaseBank2UsedHours: null,
		leaveCaseBank2FutureHours: null,

		leaveCaseBank3UsedHours: null,
		leaveCaseBank3FutureHours: null,

		leaveCaseBank4UsedHours: null,
		leaveCaseBank4FutureHours: null,

		leaveCaseBank5UsedHours: null,
		leaveCaseBank5FutureHours: null,

		leaveCaseBucket1UsedHours: null,
		leaveCaseBucket1FutureHours: null,

		leaveCaseBucket2UsedHours: null,
		leaveCaseBucket2FutureHours: null,

		leaveCaseBucket3UsedHours: null,
		leaveCaseBucket3FutureHours: null,

		leaveCaseBucket4UsedHours: null,
		leaveCaseBucket4FutureHours: null,
	};
	
	Object.keys(obj).forEach(key => {
		leaveHourFields.push(key);
	});

	return leaveHourFields;
}